<template>
  <v-layout justify-center>
    <v-snackbar top v-model="snackBarDisplayed">The password for {{user.firstName}} {{user.lastName}} has been changed.</v-snackbar>
    <v-flex>
      <v-dialog v-model="value" persistent max-width="350px">
        <v-form ref="form">
          <v-card @keyup.enter="updateClicked">
            <v-card-title class="text-xs-center">
              <v-flex class="headline">New Password for<br>{{user.firstName}} {{user.lastName}}</v-flex>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-layout>
                  <v-flex>
                    <v-text-field label="New Password" v-model.trim="password" :rules="[required]" :disabled="updatingPassword"></v-text-field>
                    <v-alert dismissible outlined v-model="errorChangingPassword" type="error">Unable to change the password at this time.</v-alert>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions v-if="!confirming">
              <v-spacer></v-spacer>
              <v-btn @click.native="updateClicked()">Update</v-btn>
              <v-btn @click.native="cancelClicked()">Cancel</v-btn>
            </v-card-actions>
            <v-card-actions v-if="confirming">
              <v-btn @click.native="confirmClicked()" :loading="updatingPassword" :disabled="updatingPassword">Confirm</v-btn>
              <v-btn @click.native="cancelClicked()" :disabled="updatingPassword">Cancel</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
//
// See Note 3 in 'doc/Notes.txt' for information pertaining to this component.
//
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import validators from '@/utility/validators';

@Component
export default class EditPasswordDialog extends Vue {
  @Prop(Function) changePassword;
  @Prop(Object) user;
  @Prop(Boolean) value;

  confirming = false;
  updatingPassword = false;
  errorChangingPassword = false;
  snackBarDisplayed = false;
  password = this.defaultPassword;
  required = validators.required;

  @Watch('value')
  onDialogChanged(dialogOpened) {
    if (dialogOpened) {
      this.password = this.defaultPassword;
      this.confirming = false;

      // The form may not exist the very first time we open the dialog but that
      // is OK because it will not initially be invalid anyway. But we want to
      // make sure there are no invalid fields each time we re-open it.
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  }

  updateClicked() {
    if (this.$refs.form.validate()) {
      this.confirming = true;
      this.errorChangingPassword = false;
    }
  }

  confirmClicked() {
    this.updatingPassword = true;
    this.changePassword(this.user, this.password).then(() => {
      this.updatingPassword = false;
      this.snackBarDisplayed = true;
      this.closeDialog();
    }).catch((error) => {
      console.error('Error updating password:', error.message);
      this.confirming = false;
      this.updatingPassword = false;
      this.errorChangingPassword = true;
    });
  }

  cancelClicked() {
    this.closeDialog();
  }

  closeDialog() {
    // This changes the 'value' Prop in the parent component to false and
    // since it is bound to the dialog's activator, will close the dialog.
    this.$emit('input', false);
  }

  get defaultPassword() {
    return (this.$configurationData && this.$configurationData.defaultPassword) ? this.$configurationData.defaultPassword : '';
  }
}
</script>
